import { BASE_URL } from 'utils/constants';

import WellnubService from './WellnubService';

class UserService extends WellnubService {
  fetchSuscriptions = () => this.axios.get(`${BASE_URL}/v1/client/suscription`);
}

export default UserService;
